<div class="modal-content" piqetAngularDraggable>
  <div class="organization-modal">
    <ng-container *ngrxLet="projectFacade.locationProcessData$ as locationProcessData">
      <ng-container *ngrxLet="projectFacade.distanceProcessData$ as distanceProcessData">
        <ng-container *ngrxLet="projectFacade.freightProcessData$ as freightProcessData">
          <ng-container *ngrxLet="projectFacade.componentProcessData$ as componentProcessData">
            <ng-container *ngrxLet="projectFacade.fillingProcessData$ as fillingProcessList">
              <ng-container
                *ngrxLet="projectFacade.locationProcessProductData$ as locationProcessProductData"
              >
                <ng-container
                  *ngrxLet="projectFacade.distanceProcessProductData$ as distanceProcessProductData"
                >
                  <ng-container
                    *ngrxLet="projectFacade.freightProcessProductData$ as freightProcessProductData"
                  >
                    <ng-container *ngrxLet="projectFacade.replicaLocation$ as replicaLocation">
                      <ng-container *ngrxLet="projectFacade.replicaDistance$ as replicaDistance">
                        <div class="header-modal" id="modal-top">
                          <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
                          <button
                            type="button"
                            aria-label="Close"
                            class="closeModal pull-right"
                            (click)="onClose()"
                          >
                            <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
                          </button>
                        </div>

                        <div class="modal-body body-modal">
                          <form
                            [formGroup]="scenarioAddEditForm"
                            [ngClass]="{ 'disabled-popup': !showEdit }"
                          >
                            <!-- PACKAGE START -->
                            <div class="row">
                              <div class="col-12">
                                <label class="subTitleName"
                                  >Transportation of package to the filler</label
                                >
                              </div>
                            </div>
                            <div class="row" *ngrxLet="projectFacade.errMessage$ as errMessage">
                              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <button #myButton class="hidden-step-trigger"></button>
                                <div class="form-group required">
                                  <label
                                    *ngIf="scenarioAddEditForm.controls['component']?.value"
                                    class="sub-header-drpdown pb-2"
                                    >Selected component</label
                                  >
                                  <ng-select
                                    [clearable]="false"
                                    #component
                                    [items]="componentItems"
                                    bindLabel="name"
                                    [ngClass]="
                                      scenarioAddEditForm.controls['component'].value?.length > 10
                                        ? 'multi-select'
                                        : ''
                                    "
                                    [searchable]="false"
                                    formControlName="component"
                                    [searchFn]="commonInputSearch"
                                    [ngbPopover]="popContent"
                                    [autoClose]="false"
                                    triggers="manual"
                                    #compPopup="ngbPopover"
                                    placeholder="Select a component"
                                    [multiple]="true"
                                    (change)="selectedComponents($event)"
                                  >
                                    <ng-template
                                      ng-option-tmp
                                      let-item="item"
                                      let-search="searchTerm"
                                    >
                                      <div [ngOptionHighlight]="search">{{ item?.name }}</div>
                                    </ng-template>
                                  </ng-select>
                                  <div
                                    *ngIf="
                                      componentSubmitted &&
                                      scenarioAddEditForm.controls['component']?.invalid
                                    "
                                    class="input-error"
                                  >
                                    Component is required.
                                  </div>
                                  <div class="input-error">
                                    {{
                                      errMessage.includes(
                                        'Components data already
                                                                        exists'
                                      )
                                        ? 'Components already exists'
                                        : ''
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <label class="sub-header-drpdown pb-2">{{ componentMessage }}</label>
                            </div>
                            <div class="row LabelDivs">
                              <div class="col-12">
                                <label class="sub-header-drpdown"
                                  >Add transportation to filler</label
                                >
                              </div>
                            </div>
                            <!-- Transportation Selection for package -->
                            <div
                              [ngClass]="{ 'disabled-project': isComponentEmpty && !isTourActive }"
                            >
                              <ul
                                class="nav nav-pills nav-justified buttonTab"
                                id="myTab"
                                role="tablist"
                              >
                                <li
                                  class="nav-item mainLiTag"
                                  role="presentation"
                                  (click)="manualLocation(data)"
                                  *ngFor="let data of wholeData"
                                >
                                  <button
                                    id="location-tab"
                                    [ngClass]="
                                      selectedBox?.id === data?.transportaionId &&
                                      (selectLocation || selectDistance || selectCustom)
                                        ? 'nav-link active'
                                        : 'nav-link'
                                    "
                                    type="button"
                                  >
                                    <div class="image">
                                      <img
                                        [src]="data.img"
                                        [height]="data.heightImg"
                                        [width]="data.widthImg"
                                        alt=""
                                      />
                                    </div>
                                    <div class="displayName">
                                      <span
                                        [ngClass]="
                                          selectedBox?.id === data?.transportaionId &&
                                          (selectLocation || selectDistance || selectCustom)
                                            ? 'active'
                                            : ''
                                        "
                                        >{{ data.displayName }}</span
                                      >
                                    </div>
                                  </button>
                                </li>
                              </ul>
                            </div>

                            <!-- Transport button Content -->
                            <div
                              class="tab-content"
                              id="myTabContent"
                              [ngClass]="{ 'disabled-project': isComponentEmpty && !isTourActive }"
                            >
                              <!-- Location -->
                              <div class="fade show active" *ngIf="selectLocation">
                                <div class="row locationDivs">
                                  <div
                                    class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox"
                                  >
                                    <div
                                      *ngIf="locationProcessData?.length > 0"
                                      class="checkBoxAlienMent"
                                    >
                                      <div>
                                        <input
                                          type="checkbox"
                                          class="chkOverview"
                                          [ngModelOptions]="{ standalone: true }"
                                          [(ngModel)]="isCustomTruck"
                                          (change)="changeCustomTruck($event)"
                                        />
                                      </div>
                                      <div>
                                        <span class="checkbox-style">Custom truck</span>
                                      </div>
                                    </div>
                                    <div class="checkBoxAlienMent">
                                      <div>
                                        <input
                                          type="checkbox"
                                          class="chkOverview"
                                          (change)="showPorts($event)"
                                        />
                                      </div>
                                      <div>
                                        <span class="checkbox-style">Show only ports</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div
                                      class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                                    >
                                      <div></div>

                                      <div *ngIf="isCustomTruck && showCustomTruckAccess">
                                        <a
                                          class="add-link"
                                          target="_blank"
                                          routerLink="custom/customTrucks"
                                          ><span class="redirectLinkText">Add custom truck</span></a
                                        >
                                        <a
                                          class="setLinkIconPosition"
                                          target="_blank"
                                          replaceUrl="true"
                                          routerLink="custom/customTrucks"
                                        >
                                          <img
                                            src="./assets/icons/redirect-icon.svg"
                                            alt=""
                                            width="15"
                                            height="13"
                                          />
                                        </a>
                                        <span
                                          class="setLinkIconPosition"
                                          (click)="refreshTruckList()"
                                          ><img
                                            src="./assets/icons/refresh-circle.svg"
                                            alt=""
                                            width="14"
                                            height="13"
                                        /></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <label
                                    *ngIf="!!isValidPort && locationProcessData?.length > 0"
                                    class="input-error port-err"
                                    >{{ isValidPort }}</label
                                  >
                                </div>
                                <ng-container
                                  *ngrxLet="
                                    projectFacade.distanceErrorProject$ as distanceErrorProject
                                  "
                                >
                                  <div class="mt-3" *ngIf="distanceErrorProject != ''">
                                    <span class="input-error-distance">{{
                                      distanceErrorProject
                                    }}</span>
                                  </div>
                                </ng-container>
                                <div class="row grid-div">
                                  <piqet-angular-portlet
                                    *ngIf="locationProcessData?.length > 0"
                                    [hidePagination]="true"
                                    [hideSearch]="true"
                                    [gridData]="locationProcessData"
                                    (inlineDataEditEvent)="editFillingDistance($event)"
                                    [columnDefs]="transportColumnDefs"
                                    [frameworkComponents]="frameworkComponents"
                                    [gridName]="'Transport Process'"
                                    [class]="'p-0'"
                                  >
                                  </piqet-angular-portlet>
                                </div>
                                <div
                                  class="row"
                                  *ngIf="locationProcessData?.length < 1 || checkIsOrginBtn"
                                >
                                  <div class="col-6">
                                    <div class="d-flex justify-content-end align-items-end">
                                      <p class="highlights" placeholder="Origin">
                                        Select locations with "(Port)" for shipping
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="row"
                                  *ngIf="locationProcessData?.length < 1 || checkIsOrginBtn"
                                >
                                  <div class="col-sm-6">
                                    <div class="form-group required">
                                      <ng-autocomplete
                                        [searchKeyword]="keyword"
                                        #autoForOrigin
                                        class="supplierdrpdown"
                                        [data]="selectedCities"
                                        placeholder="Origin"
                                        [itemTemplate]="itemTemplate"
                                        (inputCleared)="onClearSearch($event)"
                                        [notFoundTemplate]="notFoundTemplate"
                                        (inputChanged)="onChangeSearch($event, 'origin')"
                                        (keydown)="onKeyDownEvent($event)"
                                        (selected)="selectEvent($event)"
                                        formControlName="origin"
                                        [isLoading]="isLoading"
                                        (scrolledToEnd)="onScroll('origin')"
                                        [(ngModel)]="keywordAuto"
                                      >
                                      </ng-autocomplete>
                                      <ng-template #itemTemplate let-item>
                                        <div class="item">
                                          <span [innerHTML]="item.name"></span>
                                          &nbsp;
                                        </div>
                                      </ng-template>

                                      <ng-template #notFoundTemplate let-notFound>
                                        <div [innerHTML]="notFound"></div>
                                      </ng-template>
                                    </div>
                                    <div
                                      *ngIf="setOriginsubmitted && disableOrigin"
                                      class="input-error"
                                    >
                                      Please select a valid city from list.
                                    </div>
                                  </div>
                                  <div class="col-sm-1 tooltip-icon">
                                    <span
                                      placement="auto"
                                      tooltipClass="sku-tooltip"
                                      ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                                    >
                                      <a class="info-icon">
                                        <span>
                                          <img
                                            src="./assets/icons/grey-question-icon.svg"
                                            width="14"
                                            height="14"
                                        /></span>
                                      </a>
                                    </span>
                                  </div>
                                  <div
                                    class="col-5"
                                    *ngIf="locationProcessData?.length < 1 || checkIsOrginBtn"
                                  >
                                    <div class="add-button">
                                      <button
                                        class="modelBtn setOriginBtn pull-right"
                                        *ngIf="!isCheckUpdateOrigin"
                                        (click)="setLocation()"
                                      >
                                        Set origin
                                      </button>
                                      <button
                                        class="modelBtn setOriginBtn pull-right"
                                        *ngIf="isCheckUpdateOrigin"
                                        (click)="setLocation()"
                                      >
                                        Update
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div
                                    class="row"
                                    *ngIf="locationProcessData?.length >= 1 && !checkIsOrginBtn"
                                  >
                                    <div class="col-4 text-margin">
                                      <div class="d-flex justify-content-end ms-5">
                                        <p
                                          class="highlights"
                                          [ngClass]="
                                            scenarioAddEditForm.controls['transportModeForLocation']
                                              .value
                                              ? 'custom-text-position'
                                              : ''
                                          "
                                          placeholder="Origin"
                                        >
                                          Select locations with "(Port)" for shipping
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="row"
                                    *ngIf="locationProcessData?.length >= 1 && !checkIsOrginBtn"
                                  >
                                    <div class="col-md-4">
                                      <label
                                        *ngIf="
                                          scenarioAddEditForm.controls['transportModeForLocation']
                                            .value
                                        "
                                        class="placeholder-sub-header pb-2"
                                        >Holder_text</label
                                      >
                                      <div>
                                        <ng-autocomplete
                                          [data]="selectedCities"
                                          #autoForDestination
                                          class="supplierdrpdown"
                                          [searchKeyword]="keyword"
                                          historyIdentifier="selectedCities"
                                          [isLoading]="isLoading"
                                          [itemTemplate]="itemTemplate"
                                          (inputChanged)="onChangeSearch($event, 'destination')"
                                          (inputCleared)="onClearSearch($event)"
                                          (selected)="selectEvent($event)"
                                          [notFoundTemplate]="notFoundTemplate"
                                          placeholder="Destination"
                                          (keydown)="onKeyDownEvent($event)"
                                          formControlName="destination"
                                          (scrolledToEnd)="onScroll('destination')"
                                          [(ngModel)]="keywordAuto"
                                        >
                                        </ng-autocomplete>

                                        <ng-template #itemTemplate let-item>
                                          <div class="item">
                                            <span [innerHTML]="item.name"></span>
                                            &nbsp;
                                          </div>
                                        </ng-template>

                                        <ng-template #notFoundTemplate let-notFound>
                                          <div [innerHTML]="notFound"></div>
                                        </ng-template>
                                      </div>

                                      <div
                                        *ngIf="
                                          setDestinationsubmitted &&
                                          !scenarioAddEditForm.controls[
                                            'destination'
                                          ]?.value?.hasOwnProperty('name')
                                        "
                                        class="input-error destinatioErrorMessage"
                                      >
                                        Please select a valid city from list.
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div aria-required="true">
                                        <label
                                          *ngIf="
                                            scenarioAddEditForm.controls['transportModeForLocation']
                                              .value
                                          "
                                          class="sub-header-drpdown pb-2"
                                          >Transport mode</label
                                        >
                                        <ng-select
                                          [clearable]="true"
                                          [clearOnBackspace]="false"
                                          #select
                                          [items]="transportModeList"
                                          [searchable]="false"
                                          formControlName="transportModeForLocation"
                                          (change)="changeTransportMode($event, 'location')"
                                          bindLabel="name"
                                          [searchFn]="commonInputSearch"
                                          placeholder="Transport mode"
                                        >
                                          <ng-template ng-header-tmp>
                                            <div class="has-feedback">
                                              <input
                                                class="search"
                                                type="text"
                                                class="form-control accordion-search search-input"
                                                id="inputValidation"
                                                placeholder="Search..."
                                                (input)="select.filter($any($event.target).value)"
                                              />
                                              <span class="form-control-feedback">
                                                <i class="fa fa-search icon"></i>
                                              </span>
                                            </div>
                                          </ng-template>
                                          <ng-template
                                            ng-option-tmp
                                            let-item="item"
                                            let-search="searchTerm"
                                          >
                                            <div [ngOptionHighlight]="search">
                                              {{ item?.name }}
                                            </div>
                                          </ng-template>
                                        </ng-select>
                                      </div>
                                      <div
                                        *ngIf="
                                          setDestinationsubmitted &&
                                          !scenarioAddEditForm.controls['transportModeForLocation']
                                            .value
                                        "
                                        class="input-error"
                                      >
                                        Please select transport mode
                                      </div>
                                    </div>
                                    <div class="col-md-4" *ngIf="isCheckUpdateDestination">
                                      <div class="form-group required" aria-required="true">
                                        <label
                                          *ngIf="
                                            scenarioAddEditForm.controls['transportModeForLocation']
                                              .value
                                          "
                                          class="placeholder-sub-header pb-2"
                                          >Holder_text</label
                                        >
                                        <div class="services-form">
                                          <input
                                            (keydown)="noSpecialKeys($event)"
                                            placeholder="Distance"
                                            formControlName="distanceManulaLocation"
                                          />
                                          <label>Distance </label>
                                        </div>
                                        <div *ngIf="setDestinationsubmitted">
                                          <div
                                            *ngIf="
                                              scenarioAddEditForm.controls['distanceManulaLocation']
                                                .value == 0
                                            "
                                            class="input-error"
                                          >
                                            The number of licenses must be greater than 0
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <label
                                        *ngIf="
                                          scenarioAddEditForm.controls['transportModeForLocation']
                                            .value
                                        "
                                        class="placeholder-sub-header pb-2"
                                        >Holder_text</label
                                      >
                                      <div>
                                        <button
                                          class="modelBtn setOriginBtn"
                                          *ngIf="!isCheckUpdateDestination"
                                          (click)="setDestination()"
                                        >
                                          Add transport leg
                                        </button>
                                        <button
                                          class="modelBtn setOriginBtn"
                                          *ngIf="isCheckUpdateDestination"
                                          (click)="setDestination()"
                                        >
                                          Update
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Distance -->
                              <div class="fade show" *ngIf="selectDistance">
                                <div class="row locationDivs">
                                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <div class="d-flex checkBoxAlienMent">
                                      <div>
                                        <input
                                          type="checkbox"
                                          [ngModelOptions]="{ standalone: true }"
                                          [(ngModel)]="isCustomTruck"
                                          (change)="changeCustomTruckDistance($event)"
                                          class="chkOverview"
                                        />
                                      </div>
                                      <div>
                                        <span class="checkbox-style">Custom truck</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <div
                                      class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                                    >
                                      <div *ngIf="showEdit && showCustomTruckAccess">
                                        <a
                                          class="add-link"
                                          target="_blank"
                                          routerLink="custom/customTrucks"
                                          ><span class="redirectLinkText">Add custom truck</span></a
                                        >
                                        <a
                                          class="setLinkIconPosition"
                                          target="_blank"
                                          replaceUrl="true"
                                          routerLink="custom/customTrucks"
                                        >
                                          <img
                                            src="./assets/icons/redirect-icon.svg"
                                            alt=""
                                            width="15"
                                            height="13"
                                          />
                                        </a>
                                        <span
                                          class="setLinkIconPosition"
                                          (click)="refreshTruckList()"
                                          ><img
                                            src="./assets/icons/refresh-circle.svg"
                                            alt=""
                                            width="14"
                                            height="13"
                                        /></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!-- Distance scenario table starts -->
                                <div class="row grid-div">
                                  <piqet-angular-portlet
                                    *ngIf="distanceProcessData?.length > 0"
                                    [hidePagination]="true"
                                    [hideSearch]="true"
                                    [gridData]="distanceProcessData"
                                    [columnDefs]="distanceColumnDefs"
                                    [frameworkComponents]="frameworkComponents"
                                    [gridName]="'Distance transport Process'"
                                    [class]="'p-0'"
                                  >
                                  </piqet-angular-portlet>
                                </div>
                                <!-- Distance scenario table ends -->

                                <div class="row mt-3">
                                  <div
                                    class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                  >
                                    <div class="required">
                                      <label
                                        *ngIf="
                                          scenarioAddEditForm.controls['transportModeForDistance']
                                            .value
                                        "
                                        class="sub-header-drpdown pb-2"
                                        >Transport mode</label
                                      >
                                      <ng-select
                                        [clearable]="true"
                                        [clearOnBackspace]="false"
                                        #transportMode
                                        [items]="transportModeList"
                                        bindLabel="name"
                                        (change)="changeTransportMode($event, 'distance')"
                                        [searchable]="false"
                                        formControlName="transportModeForDistance"
                                        [searchFn]="commonInputSearch"
                                        placeholder="Transport mode"
                                      >
                                        <ng-template ng-header-tmp>
                                          <div class="has-feedback">
                                            <input
                                              type="text"
                                              class="form-control accordion-search search-input"
                                              id="inputValidation"
                                              placeholder="Search..."
                                              (input)="
                                                transportMode.filter($any($event.target).value)
                                              "
                                            />
                                            <span class="form-control-feedback">
                                              <i class="fa fa-search icon"></i>
                                            </span>
                                          </div>
                                        </ng-template>
                                        <ng-template
                                          ng-option-tmp
                                          let-item="item"
                                          let-search="searchTerm"
                                        >
                                          <div [ngOptionHighlight]="search">
                                            {{ item?.name }}
                                          </div>
                                        </ng-template>
                                      </ng-select>
                                    </div>
                                    <div
                                      *ngIf="
                                        transportModeErrDistance &&
                                        !scenarioAddEditForm.controls['transportModeForDistance']
                                          .value
                                      "
                                      class="input-error"
                                    >
                                      Please select transport mode
                                    </div>
                                  </div>
                                  <div
                                    class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                  >
                                    <div class="required" aria-required="true">
                                      <label
                                        *ngIf="
                                          scenarioAddEditForm.controls['transportModeForDistance']
                                            .value
                                        "
                                        class="placeholder-sub-header pb-2"
                                        >Holder_text</label
                                      >
                                      <div class="services-form">
                                        <input
                                          formControlName="distance"
                                          type="number"
                                          maxlength="100"
                                          placeholder="Component name"
                                        />
                                        <label>Distance</label>
                                      </div>
                                    </div>
                                    <div
                                      class="input-error"
                                      *ngIf="
                                        transportModeErrDistance &&
                                        !scenarioAddEditForm.controls['distance'].value
                                      "
                                    >
                                      Please enter distance
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div
                                    class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                  >
                                    <div class="add-comp-button">
                                      <button
                                        class="modelBtn purple-button-leg"
                                        *ngIf="!isCheckEditManudalDist"
                                        (click)="addTransportLeg()"
                                      >
                                        Add transport leg
                                      </button>
                                      <button
                                        class="purple-button-leg"
                                        *ngIf="isCheckEditManudalDist"
                                        (click)="addTransportLeg()"
                                      >
                                        Update
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Custom -->
                              <div class="fade show" *ngIf="selectCustom">
                                <div class="row mt-3">
                                  <div>
                                    <div class="col-12">
                                      <div class="d-flex justify-content-end">
                                        <div></div>
                                        <div *ngIf="showEdit && showCustomTransportAccess">
                                          <a
                                            class="add-link"
                                            target="_blank"
                                            routerLink="custom/customTransport"
                                            ><span class="redirectLinkText"
                                              >Add custom transport scenario</span
                                            ></a
                                          >
                                          <a
                                            class="setLinkIconPosition"
                                            target="_blank"
                                            replaceUrl="true"
                                            routerLink="custom/customTransport"
                                          >
                                            <img
                                              src="./assets/icons/redirect-icon.svg"
                                              alt=""
                                              width="15"
                                              height="13"
                                            />
                                          </a>
                                          <span
                                            class="setLinkIconPosition"
                                            (click)="getCustomTransport()"
                                            ><img
                                              src="./assets/icons/refresh-circle.svg"
                                              alt=""
                                              width="14"
                                              height="13"
                                          /></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row locationDivs">
                                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div class="form-group required">
                                      <label
                                        *ngIf="scenarioAddEditForm.controls['customFreight'].value"
                                        class="sub-header-drpdown pb-2"
                                        >Selected custom freight mode</label
                                      >
                                      <ng-select
                                        [clearable]="true"
                                        [clearOnBackspace]="false"
                                        #freightMode
                                        [items]="transportFreightModeList"
                                        bindLabel="name"
                                        [searchable]="false"
                                        formControlName="customFreight"
                                        (change)="selectFreight($event)"
                                        (clear)="resetTransport()"
                                        [searchFn]="commonInputSearch"
                                        placeholder="Custom freight mode"
                                      >
                                        <ng-template ng-header-tmp>
                                          <div class="has-feedback">
                                            <input
                                              type="text"
                                              class="form-control accordion-search search-input"
                                              id="inputValidation"
                                              placeholder="Search..."
                                              (input)="
                                                freightMode.filter($any($event.target).value)
                                              "
                                            />
                                            <span class="form-control-feedback">
                                              <i class="fa fa-search icon"></i>
                                            </span>
                                          </div>
                                        </ng-template>
                                        <ng-template
                                          ng-option-tmp
                                          let-item="item"
                                          let-search="searchTerm"
                                        >
                                          <div [ngOptionHighlight]="search">
                                            {{ item?.name }}
                                          </div>
                                        </ng-template>
                                      </ng-select>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                  >
                                    <div class="add-comp-button text-margin">
                                      <button
                                        class="modelBtn purple-button-leg"
                                        (click)="addCustomFreight()"
                                      >
                                        Add transport leg
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div class="row grid-div" *ngIf="freightProcessData?.length > 0">
                                  <piqet-angular-portlet
                                    [hidePagination]="true"
                                    [hideSearch]="true"
                                    [gridData]="freightProcessData"
                                    [columnDefs]="customFreightColumnDefs"
                                    [frameworkComponents]="frameworkComponents"
                                    [gridName]="'custom freight transport Process'"
                                    [class]="'p-0'"
                                  >
                                  </piqet-angular-portlet>
                                </div>
                              </div>
                            </div>

                            <div
                              class="row"
                              [ngClass]="{ 'disabled-project': isComponentEmpty && !isTourActive }"
                            >
                              <div
                                class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 commonBtnMarginForGrid"
                              >
                                <div class="add-comp-button">
                                  <button
                                    [ngbPopover]="popContentTwo"
                                    [autoClose]="false"
                                    triggers="manual"
                                    #transportPopup="ngbPopover"
                                    (click)="
                                      addComponentTransport(
                                        locationProcessData,
                                        distanceProcessData,
                                        freightProcessData
                                      )
                                    "
                                    class="modelBtn purple-button purpleBtnHoverEffect"
                                  >
                                    Add component transport
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div class="row grid-div">
                              <piqet-angular-portlet
                                [hidePagination]="true"
                                [hideSearch]="true"
                                [gridData]="componentProcessData"
                                [columnDefs]="componentColumnDefs"
                                [frameworkComponents]="frameworkComponents"
                                [gridName]="'component transport Process'"
                                [isChekIniline]="true"
                                [class]="'p-0'"
                              >
                              </piqet-angular-portlet>
                            </div>

                            <!-- PACKAGE END -->

                            <hr class="my-4" *ngIf="packageAccountedProductId == 2" />

                            <!-- PRODUCT START -->
                            <div *ngIf="packageAccountedProductId == 2">
                              <div class="row">
                                <div class="col-12">
                                  <label class="subTitleName"
                                    >Transportation of product to the filler</label
                                  >
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12 col-sm-12">
                                  <div class="custom-space">
                                    <label
                                      *ngIf="scenarioAddEditForm.controls['product']?.value"
                                      class="sub-header-drpdown pb-2"
                                      >Product</label
                                    >
                                    <ng-select
                                      [clearable]="true"
                                      [clearOnBackspace]="false"
                                      #productFiller
                                      [items]="productItems"
                                      bindLabel="name"
                                      [searchable]="false"
                                      formControlName="product"
                                      [searchFn]="commonInputSearch"
                                      placeholder="Product"
                                      [multiple]="true"
                                      (change)="selectedProduct($event)"
                                    >
                                      <ng-template ng-header-tmp>
                                        <div class="has-feedback">
                                          <input
                                            class="search"
                                            type="text"
                                            class="form-control accordion-search search-input"
                                            id="inputValidation"
                                            placeholder="Search..."
                                            (input)="
                                              productFiller.filter($any($event.target).value)
                                            "
                                          />
                                          <span class="form-control-feedback">
                                            <i class="fa fa-search icon"></i>
                                          </span>
                                        </div>
                                      </ng-template>
                                      <ng-template
                                        ng-option-tmp
                                        let-item="item"
                                        let-search="searchTerm"
                                      >
                                        <div [ngOptionHighlight]="search">
                                          {{ item?.name }}
                                        </div>
                                      </ng-template>
                                    </ng-select>
                                  </div>
                                </div>
                                <div
                                  class="input-error pb-2"
                                  *ngIf="
                                    productSubmitted &&
                                    scenarioAddEditForm.controls['product'].invalid
                                  "
                                >
                                  Please select a product
                                </div>
                                <div
                                  class="input-error"
                                  *ngrxLet="projectFacade.storeerr$ as storeerr"
                                >
                                  {{
                                    storeerr.includes('product data already exists')
                                      ? 'Product already exists'
                                      : ''
                                  }}
                                </div>
                              </div>
                              <div>
                                <label class="sub-header-drpdown pb-2">{{ productMessage }}</label>
                              </div>
                              <div
                                [ngClass]="{ 'disabled-project': isProductEmpty && !isTourActive }"
                              >
                                <!-- Transportation Selection for package -->
                                <div class="mb-2 mt-1">
                                  <div>
                                    <ul
                                      class="nav nav-pills nav-justified buttonTab"
                                      id="myTabProduct"
                                      role="tablistProduct"
                                    >
                                      <li
                                        class="nav-item mainLiTag"
                                        role="presentation"
                                        (click)="manualLocationProduct(data)"
                                        *ngFor="let data of wholeDataProduct"
                                      >
                                        <button
                                          id="location-tab"
                                          [ngClass]="
                                            selectedProductBox?.id ===
                                              data?.productTransportaionId &&
                                            (selectLocationProduct ||
                                              selectDistanceProduct ||
                                              selectCustomProduct)
                                              ? 'nav-link active'
                                              : 'nav-link'
                                          "
                                          type="button"
                                        >
                                          <div class="image">
                                            <img
                                              [src]="data.img"
                                              [height]="data.heightImg"
                                              [width]="data.widthImg"
                                              alt=""
                                            />
                                          </div>
                                          <div class="displayName">
                                            <span
                                              [ngClass]="
                                                selectedProductBox?.id ===
                                                  data?.productTransportaionId &&
                                                (selectLocationProduct ||
                                                  selectDistanceProduct ||
                                                  selectCustomProduct)
                                                  ? 'active'
                                                  : ''
                                              "
                                              >{{ data.displayName }}</span
                                            >
                                          </div>
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <!-- Transport button Content -->
                                <div class="tab-content" id="myTabContent">
                                  <!-- Location -->
                                  <div
                                    class="fade show active"
                                    *ngIf="selectLocationProduct"
                                    id="locationProduct"
                                    role="tabpanel"
                                    aria-labelledby="home-tab"
                                  >
                                    <div class="row locationDivs productDiv">
                                      <div
                                        class="col-sm-2"
                                        *ngIf="locationProcessProductData?.length > 0"
                                      >
                                        <div class="d-flex checkBoxAlienMent">
                                          <div>
                                            <input
                                              type="checkbox"
                                              [ngModelOptions]="{ standalone: true }"
                                              [(ngModel)]="isCustomTruckProduct"
                                              (change)="customTruckProduct($event)"
                                              class="chkOverview"
                                            />
                                          </div>
                                          <div>
                                            <span class="checkbox-style">Custom truck</span>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-sm-2">
                                        <div class="d-flex checkBoxAlienMent">
                                          <div>
                                            <input
                                              type="checkbox"
                                              (change)="showPortsProduct($event)"
                                              class="chkOverview"
                                            />
                                          </div>
                                          <div>
                                            <span class="checkbox-style setPort"
                                              >Show only ports</span
                                            >
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-4 offset-4">
                                        <div
                                          *ngIf="isCustomTruckProduct"
                                          class="d-flex justify-content-end"
                                        >
                                          <div *ngIf="showEdit && showCustomTruckAccess">
                                            <a
                                              class="add-link"
                                              target="_blank"
                                              routerLink="custom/customTrucks"
                                              ><span class="redirectLinkText"
                                                >Add custom truck</span
                                              ></a
                                            >
                                            <a
                                              class="setLinkIconPosition"
                                              target="_blank"
                                              replaceUrl="true"
                                              routerLink="custom/customTrucks"
                                            >
                                              <img
                                                src="./assets/icons/redirect-icon.svg"
                                                alt=""
                                                width="15"
                                                height="13"
                                              />
                                            </a>
                                            <span
                                              class="setLinkIconPosition"
                                              (click)="refreshTruckList()"
                                              ><img
                                                src="./assets/icons/refresh-circle.svg"
                                                alt=""
                                                width="14"
                                                height="13"
                                            /></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="port-err-product">
                                      <label
                                        *ngIf="
                                          !!isValidPortProduct &&
                                          locationProcessProductData?.length > 0
                                        "
                                        class="input-error"
                                        >{{ isValidPortProduct }}</label
                                      >
                                    </div>
                                    <ng-container
                                      *ngrxLet="
                                        projectFacade.distanceErrorProjectProduct$ as distanceErrorProjectProduct
                                      "
                                    >
                                      <div class="mt-3" *ngIf="distanceErrorProjectProduct != ''">
                                        <span class="input-error-distance">{{
                                          distanceErrorProjectProduct
                                        }}</span>
                                      </div>
                                    </ng-container>
                                    <div class="row grid-div">
                                      <piqet-angular-portlet
                                        *ngIf="locationProcessProductData?.length > 0"
                                        [hidePagination]="true"
                                        [hideSearch]="true"
                                        [gridData]="locationProcessProductData"
                                        (inlineDataEditEvent)="editFillingDistanceProduct($event)"
                                        [columnDefs]="transportProductColumnDefs"
                                        [frameworkComponents]="frameworkComponents"
                                        [gridName]="'Transport Process product'"
                                        [class]="'p-0'"
                                      >
                                      </piqet-angular-portlet>
                                    </div>
                                    <div
                                      class="row"
                                      *ngIf="
                                        locationProcessProductData?.length < 1 ||
                                        checkIsOrginBtnProduct
                                      "
                                    >
                                      <div class="col-6">
                                        <div class="d-flex justify-content-end align-items-end">
                                          <p class="highlights" placeholder="Origin">
                                            Select locations with "(Port)" for shipping
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="row"
                                      *ngIf="
                                        locationProcessProductData?.length < 1 ||
                                        checkIsOrginBtnProduct
                                      "
                                    >
                                      <div class="col-sm-6">
                                        <div class="form-group required">
                                          <ng-autocomplete
                                            [searchKeyword]="keyword"
                                            (inputCleared)="onClearSearchProduct($event)"
                                            #autoForOriginProduct
                                            class="supplierdrpdown"
                                            [data]="selectedCitiesProduct"
                                            placeholder="Origin"
                                            [itemTemplate]="itemTemplate"
                                            [notFoundTemplate]="notFoundTemplate"
                                            (inputChanged)="onChangeSearch($event, 'originProduct')"
                                            (selected)="selectEvent($event)"
                                            formControlName="originProduct"
                                            (keydown)="onKeyDownEvent($event)"
                                            [isLoading]="isLoadingProduct"
                                            (scrolledToEnd)="onScroll('originProduct')"
                                            [(ngModel)]="keywordAuto"
                                          >
                                          </ng-autocomplete>
                                          <ng-template #itemTemplate let-item>
                                            <div class="item">
                                              <span [innerHTML]="item.name"></span>
                                              &nbsp;
                                            </div>
                                          </ng-template>

                                          <ng-template #notFoundTemplate let-notFound>
                                            <div [innerHTML]="notFound"></div>
                                          </ng-template>
                                        </div>
                                        <div
                                          *ngIf="setOriginProductsubmitted && disableOriginProduct"
                                          class="input-error"
                                        >
                                          Please select a valid city from list.
                                        </div>
                                      </div>
                                      <div class="col-sm-1 tooltip-icon">
                                        <span
                                          placement="auto"
                                          tooltipClass="sku-tooltip"
                                          ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                                        >
                                          <a class="info-icon">
                                            <span>
                                              <img
                                                src="./assets/icons/grey-question-icon.svg"
                                                width="14"
                                                height="14"
                                            /></span>
                                          </a>
                                        </span>
                                      </div>
                                      <div
                                        class="col-5"
                                        *ngIf="
                                          locationProcessProductData?.length < 1 ||
                                          checkIsOrginBtnProduct
                                        "
                                      >
                                        <div class="add-button">
                                          <button
                                            class="modelBtn setOriginBtn pull-right"
                                            *ngIf="!isCheckUpdateOriginProduct"
                                            (click)="setLocationProduct()"
                                          >
                                            Set origin
                                          </button>
                                          <button
                                            class="modelBtn setOriginBtn pull-right"
                                            *ngIf="isCheckUpdateOriginProduct"
                                            (click)="setLocationProduct()"
                                          >
                                            Update
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <!-- Destination for product -->
                                      <div
                                        class="row mt-3"
                                        *ngIf="
                                          locationProcessProductData?.length >= 1 &&
                                          !checkIsOrginBtnProduct
                                        "
                                      >
                                        <div class="col-4 text-margin">
                                          <div class="d-flex justify-content-end align-items-end">
                                            <p
                                              class="highlights"
                                              [ngClass]="
                                                scenarioAddEditForm.controls[
                                                  'transportModeForLocationProduct'
                                                ].value
                                                  ? 'custom-text-position'
                                                  : ''
                                              "
                                              placeholder="Origin"
                                            >
                                              Select locations with "(Port)" for shipping
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="row"
                                        *ngIf="
                                          locationProcessProductData?.length >= 1 &&
                                          !checkIsOrginBtnProduct
                                        "
                                      >
                                        <div class="col-md-4">
                                          <label
                                            *ngIf="
                                              scenarioAddEditForm.controls[
                                                'transportModeForLocationProduct'
                                              ].value
                                            "
                                            class="placeholder-sub-header pb-2"
                                            >Holder_text</label
                                          >
                                          <div>
                                            <ng-autocomplete
                                              [data]="selectedCitiesProduct"
                                              #autoForDestinationProduct
                                              class="supplierdrpdown"
                                              [searchKeyword]="keyword"
                                              historyIdentifier="selectedCitiesProduct"
                                              [itemTemplate]="itemTemplate"
                                              (inputChanged)="
                                                onChangeSearch($event, 'destinationProduct')
                                              "
                                              (selected)="selectEvent($event)"
                                              [notFoundTemplate]="notFoundTemplate"
                                              placeholder="Destination"
                                              formControlName="destinationProduct"
                                              (inputCleared)="onClearSearchProduct($event)"
                                              [(ngModel)]="keywordAuto"
                                              (keydown)="onKeyDownEvent($event)"
                                              [isLoading]="isLoadingProduct"
                                              (scrolledToEnd)="onScroll('destinationProduct')"
                                            >
                                            </ng-autocomplete>

                                            <ng-template #itemTemplate let-item>
                                              <div class="item">
                                                <span [innerHTML]="item.name"></span>
                                                &nbsp;
                                              </div>
                                            </ng-template>

                                            <ng-template #notFoundTemplate let-notFound>
                                              <div [innerHTML]="notFound"></div>
                                            </ng-template>
                                          </div>
                                          <div
                                            *ngIf="
                                              setDestinationProducsubmitted &&
                                              disableDestinationProduct
                                            "
                                            class="input-error destinatioErrorMessage"
                                          >
                                            Select a valid city from list.
                                          </div>
                                        </div>
                                        <div class="col-md-4">
                                          <div aria-required="true">
                                            <label
                                              *ngIf="
                                                scenarioAddEditForm.controls[
                                                  'transportModeForLocationProduct'
                                                ].value
                                              "
                                              class="sub-header-drpdown pb-2"
                                              >Transport mode</label
                                            >
                                            <ng-select
                                              [clearable]="true"
                                              [clearOnBackspace]="false"
                                              #select
                                              [items]="transportModeListProduct"
                                              [searchable]="false"
                                              formControlName="transportModeForLocationProduct"
                                              (change)="
                                                changeTransportModeProduct(
                                                  $event,
                                                  'locationProduct'
                                                )
                                              "
                                              bindLabel="name"
                                              [searchFn]="commonInputSearch"
                                              placeholder="Transport mode"
                                            >
                                              <ng-template ng-header-tmp>
                                                <div class="has-feedback">
                                                  <input
                                                    type="text"
                                                    class="form-control search-input search"
                                                    id="inputValidation"
                                                    placeholder="Search..."
                                                    (input)="
                                                      select.filter($any($event.target).value)
                                                    "
                                                  />
                                                  <span class="form-control-feedback">
                                                    <i class="fa fa-search icon"></i>
                                                  </span>
                                                </div>
                                              </ng-template>
                                              <ng-template
                                                ng-option-tmp
                                                let-item="item"
                                                let-search="searchTerm"
                                              >
                                                <div [ngOptionHighlight]="search">
                                                  {{ item?.name }}
                                                </div>
                                              </ng-template>
                                            </ng-select>
                                          </div>
                                          <div
                                            *ngIf="
                                              setDestinationProducsubmitted &&
                                              !scenarioAddEditForm.controls[
                                                'transportModeForLocationProduct'
                                              ].value
                                            "
                                            class="input-error"
                                          >
                                            Please select transport mode
                                          </div>
                                        </div>
                                        <div
                                          class="col-md-4"
                                          *ngIf="isCheckUpdateDestinationProduct"
                                        >
                                          <div class="form-group required" aria-required="true">
                                            <label
                                              *ngIf="
                                                scenarioAddEditForm.controls[
                                                  'transportModeForLocationProduct'
                                                ].value
                                              "
                                              class="placeholder-sub-header pb-2"
                                              >Holder_text</label
                                            >
                                            <div class="services-form">
                                              <input
                                                (keydown)="noSpecialKeys($event)"
                                                placeholder="Distance"
                                                formControlName="distanceManulaLocationProduct"
                                              />
                                              <label>Distance </label>
                                            </div>
                                            <div *ngIf="setDestinationProducsubmitted">
                                              <div
                                                *ngIf="
                                                  scenarioAddEditForm.controls[
                                                    'distanceManulaLocationProduct'
                                                  ].value == 0
                                                "
                                                class="input-error"
                                              >
                                                The number of licenses must be greater than 0
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-3">
                                          <label
                                            *ngIf="
                                              scenarioAddEditForm.controls[
                                                'transportModeForLocationProduct'
                                              ].value
                                            "
                                            class="placeholder-sub-header pb-2"
                                            >Holder_text</label
                                          >
                                          <div>
                                            <button
                                              class="modelBtn setOriginBtn"
                                              *ngIf="!isCheckUpdateDestinationProduct"
                                              (click)="setDestinationProduct()"
                                            >
                                              Add transport leg
                                            </button>
                                            <button
                                              class="modelBtn setOriginBtn"
                                              *ngIf="isCheckUpdateDestinationProduct"
                                              (click)="setDestinationProduct()"
                                            >
                                              Update
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Distance -->
                                  <div
                                    class="fade show"
                                    *ngIf="selectDistanceProduct"
                                    id="distanceProduct"
                                    role="tabpanel"
                                    aria-labelledby="distance-tab"
                                  >
                                    <div class="row locationDivs">
                                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <div class="d-flex checkBoxAlienMent">
                                          <div>
                                            <input
                                              type="checkbox"
                                              [ngModelOptions]="{ standalone: true }"
                                              [(ngModel)]="isCustomTruckProduct"
                                              (change)="customTruckProduct($event)"
                                              class="chkOverview"
                                            />
                                          </div>
                                          <div>
                                            <span class="checkbox-style">Custom truck</span>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <div
                                          class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                                        >
                                          <div *ngIf="showEdit && showCustomTruckAccess">
                                            <a
                                              class="add-link"
                                              target="_blank"
                                              routerLink="custom/customTrucks"
                                              ><span class="redirectLinkText"
                                                >Add custom truck</span
                                              ></a
                                            >
                                            <a
                                              class="setLinkIconPosition"
                                              target="_blank"
                                              replaceUrl="true"
                                              routerLink="custom/customTrucks"
                                            >
                                              <img
                                                src="./assets/icons/redirect-icon.svg"
                                                alt=""
                                                width="15"
                                                height="13"
                                              />
                                            </a>
                                            <span
                                              class="setLinkIconPosition"
                                              (click)="refreshTruckList()"
                                              ><img
                                                src="./assets/icons/refresh-circle.svg"
                                                alt=""
                                                width="14"
                                                height="13"
                                            /></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row grid-div">
                                      <piqet-angular-portlet
                                        *ngIf="distanceProcessProductData?.length > 0"
                                        [hidePagination]="true"
                                        [hideSearch]="true"
                                        [gridData]="distanceProcessProductData"
                                        [columnDefs]="distanceProductColumnDefs"
                                        [frameworkComponents]="frameworkComponents"
                                        [gridName]="'Distance process'"
                                        [class]="'detail-cell-renderer p-0'"
                                      >
                                      </piqet-angular-portlet>
                                    </div>

                                    <div class="row checkboxDivs">
                                      <div
                                        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                      >
                                        <div class="required">
                                          <label
                                            *ngIf="
                                              scenarioAddEditForm.controls[
                                                'transportModeForDistanceProduct'
                                              ]?.value
                                            "
                                            class="sub-header-drpdown pb-2"
                                            >Transport mode</label
                                          >
                                          <ng-select
                                            [clearable]="true"
                                            [clearOnBackspace]="false"
                                            #transportModeProduct
                                            [items]="transportModeListProduct"
                                            bindLabel="name"
                                            [searchable]="false"
                                            formControlName="transportModeForDistanceProduct"
                                            (change)="
                                              changeTransportModeProduct($event, 'distanceProduct')
                                            "
                                            [searchFn]="commonInputSearch"
                                            placeholder="Transport mode"
                                          >
                                            <ng-template ng-header-tmp>
                                              <div class="has-feedback">
                                                <input
                                                  type="text"
                                                  class="form-control accordion-search search-input"
                                                  id="inputValidation"
                                                  placeholder="Search..."
                                                  (input)="
                                                    transportModeProduct.filter(
                                                      $any($event.target).value
                                                    )
                                                  "
                                                />
                                                <span class="form-control-feedback">
                                                  <i class="fa fa-search icon"></i>
                                                </span>
                                              </div>
                                            </ng-template>
                                            <ng-template
                                              ng-option-tmp
                                              let-item="item"
                                              let-search="searchTerm"
                                            >
                                              <div [ngOptionHighlight]="search">
                                                {{ item?.name }}
                                              </div>
                                            </ng-template>
                                          </ng-select>
                                        </div>
                                        <div
                                          class="input-error"
                                          *ngIf="
                                            transportModeErrDistanceProd &&
                                            !this.scenarioAddEditForm.controls[
                                              'transportModeForDistanceProduct'
                                            ].value
                                          "
                                        >
                                          Please select transport mode
                                        </div>
                                      </div>
                                      <div
                                        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                      >
                                        <div class="required" aria-required="true">
                                          <label
                                            *ngIf="
                                              scenarioAddEditForm.controls[
                                                'transportModeForDistanceProduct'
                                              ]?.value
                                            "
                                            class="placeholder-sub-header pb-2"
                                            >Holder_text</label
                                          >
                                          <div class="services-form">
                                            <input
                                              type="text"
                                              formControlName="distanceProduct"
                                              maxlength="100"
                                              type="number"
                                              placeholder="Component name"
                                            />
                                            <label>Distance</label>
                                          </div>
                                        </div>
                                        <div
                                          class="input-error"
                                          *ngIf="
                                            transportModeErrDistanceProd &&
                                            !scenarioAddEditForm.controls['distanceProduct'].value
                                          "
                                        >
                                          Please enter distance
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div
                                        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                      >
                                        <div class="add-comp-button">
                                          <button
                                            class="modelBtn purple-button-leg"
                                            *ngIf="!isCheckEditManudalDistProduct"
                                            (click)="addTransportLegProduct()"
                                          >
                                            Add transport leg
                                          </button>
                                          <button
                                            class="purple-button-leg"
                                            *ngIf="isCheckEditManudalDistProduct"
                                            (click)="addTransportLegProduct()"
                                          >
                                            Update
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Custom -->
                                  <div
                                    class="fade show"
                                    *ngIf="selectCustomProduct"
                                    id="customProduct"
                                    role="tabpanel"
                                    aria-labelledby="custom-tab"
                                  >
                                    <div class="row mt-3">
                                      <div>
                                        <div class="col-12">
                                          <div class="d-flex justify-content-end">
                                            <div></div>
                                            <div *ngIf="showEdit && showCustomTransportAccess">
                                              <a
                                                class="add-link"
                                                target="_blank"
                                                routerLink="custom/customTransport"
                                                ><span class="redirectLinkText"
                                                  >Add custom transport scenario</span
                                                ></a
                                              >
                                              <a
                                                class="setLinkIconPosition"
                                                target="_blank"
                                                replaceUrl="true"
                                                routerLink="custom/customTransport"
                                              >
                                                <img
                                                  src="./assets/icons/redirect-icon.svg"
                                                  width="15"
                                                  height="13"
                                                />
                                              </a>
                                              <span
                                                class="setLinkIconPosition"
                                                (click)="getCustomTransport()"
                                                ><img
                                                  src="./assets/icons/refresh-circle.svg"
                                                  width="14"
                                                  height="13"
                                              /></span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row locationDivs">
                                      <div
                                        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div"
                                      >
                                        <div class="form-group required">
                                          <label
                                            *ngIf="
                                              scenarioAddEditForm.controls['customFreightProduct']
                                                ?.value
                                            "
                                            class="sub-header-drpdown pb-2"
                                            >Selected custom freight mode</label
                                          >
                                          <ng-select
                                            [clearable]="true"
                                            [clearOnBackspace]="false"
                                            #freightModeProd
                                            [items]="transportFreightModeList"
                                            bindLabel="name"
                                            [searchable]="false"
                                            formControlName="customFreightProduct"
                                            (change)="selectFreightProduct($event)"
                                            (clear)="resetTransportProduct()"
                                            [searchFn]="commonInputSearch"
                                            placeholder="Custom freight mode"
                                          >
                                            <ng-template ng-header-tmp>
                                              <div class="has-feedback">
                                                <input
                                                  type="text"
                                                  class="form-control accordion-search search-input"
                                                  id="inputValidation"
                                                  placeholder="Search..."
                                                  (input)="
                                                    freightModeProd.filter(
                                                      $any($event.target).value
                                                    )
                                                  "
                                                />
                                                <span class="form-control-feedback">
                                                  <i class="fa fa-search icon"></i>
                                                </span>
                                              </div>
                                            </ng-template>
                                            <ng-template
                                              ng-option-tmp
                                              let-item="item"
                                              let-search="searchTerm"
                                            >
                                              <div [ngOptionHighlight]="search">
                                                {{ item?.name }}
                                              </div>
                                            </ng-template>
                                          </ng-select>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div
                                        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div"
                                      >
                                        <div class="add-comp-button text-margin">
                                          <button
                                            class="modelBtn purple-button-leg"
                                            (click)="addCustomFreightProduct()"
                                          >
                                            Add transport leg
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="row grid-div"
                                      *ngIf="freightProcessProductData?.length > 0"
                                    >
                                      <piqet-angular-portlet
                                        [hidePagination]="true"
                                        [hideSearch]="true"
                                        [gridData]="freightProcessProductData"
                                        [columnDefs]="customFreightColumnDefs"
                                        [frameworkComponents]="frameworkComponents"
                                        [gridName]="'custom freight product Process'"
                                        [class]="'p-0'"
                                      >
                                      </piqet-angular-portlet>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 commonBtnMarginForGrid"
                                  >
                                    <div class="add-comp-button">
                                      <button
                                        (click)="
                                          addProductTransport(
                                            locationProcessProductData,
                                            distanceProcessProductData,
                                            freightProcessProductData
                                          )
                                        "
                                        class="modelBtn purple-button purpleBtnHoverEffect"
                                      >
                                        Add product transport
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="row grid-div"
                                *ngrxLet="projectFacade.productProcessData$ as productProcessData"
                              >
                                <piqet-angular-portlet
                                  [hidePagination]="true"
                                  [hideSearch]="true"
                                  [gridData]="productProcessData"
                                  [columnDefs]="productColumnDefs"
                                  [isChekIniline]="true"
                                  [frameworkComponents]="frameworkComponents"
                                  [gridName]="'product transport Process'"
                                  [class]="'p-0'"
                                >
                                </piqet-angular-portlet>
                              </div>
                            </div>

                            <!-- PRODUCT END -->

                            <hr class="my-4" />

                            <!-- FILLING PROCESS START -->
                            <div>
                              <div class="row">
                                <div class="col-12">
                                  <label class="subTitleName"> Filling process</label>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-6 col-lg-6 custom-input-div">
                                  <div class="form-group required">
                                    <label
                                      *ngIf="
                                        scenarioAddEditForm.controls['process']?.value ||
                                        scenarioAddEditForm.controls['location']?.value
                                      "
                                      class="sub-header-drpdown pb-2"
                                      >Location</label
                                    >
                                    <ng-select
                                      [clearable]="false"
                                      [clearOnBackspace]="false"
                                      #location
                                      id="location-popover"
                                      [items]="countryList"
                                      bindLabel="name"
                                      [searchable]="false"
                                      formControlName="location"
                                      [searchFn]="commonInputSearch"
                                      [ngbPopover]="popContentThree"
                                      [autoClose]="false"
                                      triggers="manual"
                                      #locationPopup="ngbPopover"
                                      placeholder="Location *"
                                      (change)="changeLocation($event, fillingProcessList)"
                                    >
                                      <ng-template ng-header-tmp>
                                        <div class="has-feedback">
                                          <input
                                            type="text"
                                            class="form-control accordion-search search-input"
                                            id="inputValidation"
                                            placeholder="Search..."
                                            (input)="location.filter($any($event.target).value)"
                                          />
                                          <span class="form-control-feedback">
                                            <i class="fa fa-search icon"></i>
                                          </span>
                                        </div>
                                      </ng-template>
                                      <ng-template
                                        ng-option-tmp
                                        let-item="item"
                                        let-search="searchTerm"
                                      >
                                        <div [ngOptionHighlight]="search">
                                          {{ item?.name }}
                                        </div>
                                      </ng-template>
                                    </ng-select>
                                    <div
                                      class="input-error"
                                      *ngIf="
                                        fillingSubmitted &&
                                        !scenarioAddEditForm.controls['location'].valid
                                      "
                                    >
                                      Location is required
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="row my-1"
                                [piqetAngularSectionAccess]="FeatureCodes.FILLING_CUSTOM_FILLING"
                              >
                                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                  <div class="d-flex checkBoxAlienMent">
                                    <div>
                                      <input
                                        type="checkbox"
                                        (change)="toggleCustomFilling($event)"
                                        class="chkOverview"
                                      />
                                    </div>
                                    <div>
                                      <span class="checkbox-style">Custom filling</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                  <div
                                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                                  >
                                    <div *ngIf="showEdit && showCustomFillingAccess">
                                      <a
                                        class="add-link"
                                        target="_blank"
                                        routerLink="custom/customFilling"
                                        ><span class="redirectLinkText">Add custom filling</span></a
                                      >
                                      <a
                                        class="setLinkIconPosition"
                                        target="_blank"
                                        replaceUrl="true"
                                        routerLink="custom/customFilling"
                                      >
                                        <img
                                          src="./assets/icons/redirect-icon.svg"
                                          alt=""
                                          width="15"
                                          height="13"
                                        />
                                      </a>
                                      <span
                                        class="setLinkIconPosition"
                                        (click)="refreshFillingList()"
                                        ><img
                                          src="./assets/icons/refresh-circle.svg"
                                          alt=""
                                          width="14"
                                          height="13"
                                      /></span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-6 col-lg-6 custom-input-div">
                                  <div class="form-group required">
                                    <label class="sub-header-drpdown">Process</label>
                                    <ng-select
                                      [clearable]="true"
                                      [clearOnBackspace]="false"
                                      #process
                                      [items]="fillingProcess"
                                      bindLabel="name"
                                      [searchable]="false"
                                      formControlName="process"
                                      [searchFn]="commonInputSearch"
                                      (change)="selectChange($event)"
                                      placeholder="Process"
                                    >
                                      <ng-template ng-header-tmp>
                                        <div class="has-feedback">
                                          <input
                                            type="text"
                                            class="form-control accordion-search search-input"
                                            id="inputValidation"
                                            placeholder="Search..."
                                            (input)="process.filter($any($event.target).value)"
                                          />
                                          <span class="form-control-feedback">
                                            <i class="fa fa-search icon"></i>
                                          </span>
                                        </div>
                                      </ng-template>
                                      <ng-template
                                        ng-option-tmp
                                        let-item="item"
                                        let-search="searchTerm"
                                      >
                                        <div
                                          [ngOptionHighlight]="search"
                                          title="{{ item?.name }} || {{ item?.processName }}"
                                        >
                                          {{ item?.name || item?.processName }}
                                        </div>
                                      </ng-template>
                                    </ng-select>
                                    <div
                                      class="input-error"
                                      *ngIf="
                                        fillingSubmitted &&
                                        !scenarioAddEditForm.controls['process'].valid
                                      "
                                    >
                                      Please select filling process
                                    </div>
                                  </div>
                                </div>

                                <div
                                  *ngIf="!isProductContent"
                                  class="col-6 col-lg-6 custom-input-div"
                                >
                                  <div aria-required="true">
                                    <piqet-angular-common-input
                                      formControlName="amount"
                                      [control]="scenarioAddEditForm.get('amount')"
                                      label="Amount (per kg or per L of product)"
                                      placeholder="Amount (per kg or per L of product)"
                                      [preventNegative]="true"
                                      [maxLength]="50"
                                      inputType="number"
                                      [submitted]="fillingSubmitted"
                                      (customBlur)="calcCost()"
                                    ></piqet-angular-common-input>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="row"
                                *ngIf="!fillingData?.isCostTrunOff && !isProductContent"
                              >
                                <div aria-required="true" class="col-6 col-lg-6 custom-input-div">
                                  <piqet-angular-common-input
                                    formControlName="costPerUnit"
                                    [control]="scenarioAddEditForm.get('costPerUnit')"
                                    label="Cost per unit"
                                    placeholder="Cost per unit"
                                    inputType="number"
                                    [preventNegative]="true"
                                    [submitted]="fillingSubmitted"
                                    (customBlur)="calcCost()"
                                  >
                                  </piqet-angular-common-input>
                                </div>

                                <div
                                  *ngIf="!fillingData?.isCostTrunOff && !isProductContent"
                                  class="col-6 col-lg-6 custom-input-div"
                                >
                                  <div aria-required="true">
                                    <piqet-angular-common-input
                                      formControlName="costPerPackage"
                                      [control]="scenarioAddEditForm.get('costPerPackage')"
                                      label="Cost per package (USD)"
                                      placeholder="Cost per package (USD)"
                                      inputType="number"
                                      [preventNegative]="true"
                                      [submitted]="submitted"
                                    >
                                    </piqet-angular-common-input>
                                  </div>
                                </div>
                              </div>
                              <div class="row modal-footer text-margin">
                                <div class="add-button d-flex">
                                  <button
                                    type="button"
                                    (click)="addFillingProcess()"
                                    class="modelBtn addLightGray"
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                              <div class="row grid-div">
                                <piqet-angular-portlet
                                  *ngIf="fillingProcessList?.length > 0"
                                  [hidePagination]="true"
                                  [hideSearch]="true"
                                  [gridData]="fillingProcessList"
                                  [columnDefs]="fillingProcessColumnDefs"
                                  [frameworkComponents]="frameworkComponents"
                                  [gridName]="'Filling Process'"
                                  [class]="'p-0 overflowCheck'"
                                >
                                </piqet-angular-portlet>
                              </div>
                            </div>
                            <!-- FILLING PROCESS END -->

                            <hr class="my-4" />

                            <!-- PRODUCT LOSS START -->
                            <div>
                              <div class="sub-title">
                                <span class="setFont">Product loss</span>
                              </div>

                              <div class="row">
                                <div class="col-6">
                                  <ng-container
                                    *ngTemplateOutlet="packagingDestinationTemplate"
                                  ></ng-container>
                                </div>

                                <div class="col-6">
                                  <div>
                                    <label class="sub-header-drpdown"
                                      >Destination of product loss</label
                                    >
                                    <ng-select
                                      [clearable]="true"
                                      [clearOnBackspace]="false"
                                      #productLoss
                                      [items]="productLossList"
                                      bindLabel="name"
                                      [searchable]="false"
                                      formControlName="productLoss"
                                      [searchFn]="commonInputSearch"
                                      placeholder="Destination of product loss"
                                      (change)="changeProductLoss($event, 'change')"
                                      (clear)="changeProductLoss($event, 'clear')"
                                    >
                                      <ng-template ng-header-tmp>
                                        <div class="has-feedback">
                                          <input
                                            type="text"
                                            class="form-control accordion-search search-input"
                                            id="inputValidation"
                                            placeholder="Search..."
                                            (input)="productLoss.filter($any($event.target).value)"
                                          />
                                          <span class="form-control-feedback">
                                            <i class="fa fa-search icon"></i>
                                          </span>
                                        </div>
                                      </ng-template>
                                      <ng-template
                                        ng-option-tmp
                                        let-item="item"
                                        let-search="searchTerm"
                                      >
                                        <div [ngOptionHighlight]="search">
                                          {{ item?.name }}
                                        </div>
                                      </ng-template>
                                    </ng-select>
                                  </div>
                                  <div
                                    class="input-error"
                                    *ngIf="
                                      submitted &&
                                      this.scenarioAddEditForm.controls['productLoss'].invalid
                                    "
                                  >
                                    Please select destination of product loss
                                  </div>
                                </div>
                                <!-- Condition based secondary market value dropdown starts -->
                              </div>
                              <div class="row" *ngIf="secondaryMarketDropdown">
                                <div class="col-md-6 form-group required">
                                  <label class="sub-header-drpdown">Secondary market percent</label>
                                  <ng-select
                                    [clearable]="false"
                                    [clearOnBackspace]="false"
                                    [items]="secondaryMarketValueItem"
                                    formControlName="secondaryMarket"
                                    bindLabel="name"
                                    [searchable]="false"
                                    [searchFn]="commonInputSearch"
                                    placeholder="Secondary Market Percent"
                                  >
                                    <ng-template
                                      ng-option-tmp
                                      let-item="item"
                                      let-search="searchTerm"
                                    >
                                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                                        {{ item.name }}
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </div>
                            </div>
                            <!-- PRODUCT LOSS END -->

                            <ng-template #packagingDestinationTemplate>
                              <div class="form-group" aria-required="true">
                                <div
                                  [ngbPopover]="popContentFour"
                                  [autoClose]="false"
                                  triggers="manual"
                                  #lossPopup="ngbPopover"
                                >
                                  <piqet-angular-common-input
                                    formControlName="productPercentageLoss"
                                    [control]="scenarioAddEditForm.get('productPercentageLoss')"
                                    label="Product loss during filling (%)"
                                    placeholder="Product loss during filling (%)"
                                    inputType="number"
                                    [maxValue]="100"
                                    [maxLength]="100"
                                    [enableRangeValidation]="true"
                                    [preventNegative]="true"
                                    [submitted]="submitted"
                                    (customBlur)="productLossFilling($event)"
                                  >
                                  </piqet-angular-common-input>
                                </div>
                              </div>
                            </ng-template>
                          </form>
                          <div class="setButtonAndError text-margin">
                            <div
                              class="modal-footer"
                              *ngrxLet="projectFacade.productProcessData$ as productProcessData"
                            >
                              <button
                                type="button"
                                class="btn btn-light cancelBtn"
                                (click)="onClose()"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                class="modelBtn purpleBtnHoverEffect"
                                *ngIf="showEdit"
                                (click)="
                                  onSave(
                                    fillingProcessList,
                                    locationProcessProductData,
                                    distanceProcessProductData,
                                    replicaLocation,
                                    replicaDistance,
                                    componentProcessData,
                                    productProcessData
                                  )
                                "
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #popContent>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(1)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">Transport one or multiple components to the filler.</p>
    <div class="d-flex justify-content-between">
      <div class="step-counter d-flex align-items-center">1/4</div>
      <button class="modal-tour-btn" (click)="closePopup('one')">NEXT</button>
    </div>
  </ng-template>

  <ng-template #popContentTwo>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(2)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">
      Add as many transport legs as required before submitting the component transport process.
    </p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">2/4</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('two')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('two')">NEXT</button>
      </div>
    </div>
  </ng-template>

  <ng-template #popContentThree>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(3)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">
      Select the filling process and amount of units used to fill per kg or per L of product.
    </p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">3/4</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('three')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('three')">NEXT</button>
      </div>
    </div>
  </ng-template>

  <ng-template #popContentFour>
    <div class="d-flex justify-content-end pb-3">
      <button type="button" class="closePopover" aria-label="Close" (click)="closeAllSteps(4)">
        <img src="./assets/icons/pop-up-cross.svg" width="12" height="13" />
      </button>
    </div>
    <p class="modal-tour-text">Provide a product loss amount and assign its destination.</p>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="step-counter d-flex align-items-center">4/4</div>
      </div>
      <div>
        <button class="modal-tour-prev-btn" (click)="goBack('four')">PREV</button>
        <button class="modal-tour-btn" (click)="closePopup('four')">Done</button>
      </div>
    </div>
  </ng-template>
</div>
